<template>
<div class="reportDataAnalysis">
    <div class="title blod">基础数据</div>
    <div class="boxs key-data">
        <div class="box box-shadow" v-for="(item,index) in keyData" :key="index">
            <div class="summary">{{item.title}}</div>
            <div class="content">
                <div class="num">{{item.total}}</div>
                <i class="icon overflow" :class="[item.type?'icon_eye':'icon_car']"></i>
            </div>
        </div>
    </div>
    <div class="trend box-shadow">
        <div class="trendTitle">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="近7日" name="first"></el-tab-pane>
                <el-tab-pane label="近30日" name="second"></el-tab-pane>
                <el-tab-pane>
                    <span slot="label">
                        <div class="block">
                            <el-date-picker class="dateInput" value-format="yyyy-MM-dd" v-model="date" type="daterange" align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                          </div>
                    </span>
                </el-tab-pane>
            </el-tabs>
        </div>
        <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
        <lineReport :lineDatas="lineDatas2" class="lineDatas"></lineReport>
    </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {timestampFormat} from 'common/js/tools'
import {getReportDayNum, getReportNums} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'reportDataAnalysis',
    data() {
        return {
            param: {
                // stripParam: 0,
                KMCType: 2,
                beginTime: '',
                endTime: '',
                reportinnerid: this.$route.query.id,
                status: this.$route.query.status
            },
            date: '',
            activeName: 'first',
            lineDatas: {id: 'browse', subText: '报告浏览数据', data: [{title: '浏览量', color: '#1989FA', list: []}], dataList: []},
            lineDatas2: {id: 'buy', subText: '报告购买数据', data: [{title: '浏览量', color: '#E6A23C', list: []}], dataList: []},
            keyData: [{title: '浏览量', total: 0, type: 0}, {title: '购买量', total: 0, type: 1}],
        }
    },
    mounted() {
        this.param.beginTime = this.getTime(7)
        this.param.endTime = this.getTime(1)
        this._getData()
    },
    methods: {
        handleClick(tab, event) {
            // console.log(tab, event)
        },
        _getData() {
            // this.setLoading(true)
            getReportDayNum({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    console.log(data)
                    if (data.code === '000') {
                        this.lineDatas.data[0].list = data.data.visilist
                        this.lineDatas.dataList = data.data.xdate
                        this.lineDatas2.data[0].list = data.data.buylist
                        this.lineDatas2.dataList = data.data.xdate
                        let pageView = 0, purchases = 0 // 浏览量  购买量
                        for (let i = 0; i < data.data.visilist.length; i++) {
                            pageView += data.data.visilist[i]
                        }
                        for (let i = 0; i < data.data.buylist.length; i++) {
                            purchases += data.data.buylist[i]
                        }
                        this.keyData[0].total = pageView
                        this.keyData[1].total = purchases
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
            // getReportNums({
            //     data: Object.assign({}, this.param, this.page),
            //     success: data => {
            //         console.log(data)
            //         this.setLoading(false)
            //     },
            //     error: data => {
            //         this.setLoading(false)
            //         this.$message.error(data.msg)
            //     }
            // })
        },
        getTime(v) {
            return timestampFormat(new Date(new Date() - v * 24 * 60 * 60 * 1000), 'yyyy-MM-dd')
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        'date': {
            handler(newV, oldV) {
                this.param.beginTime = newV[0]
                this.param.endTime = newV[1]
                this._getData()
            }
        },
        'activeName': {
            handler(newV, oldV) {
                if (newV === 'first') {
                    this.param.beginTime = this.getTime(7)
                    this.param.endTime = this.getTime(1)
                    this._getData()
                } else if (newV === 'second') {
                    this.param.beginTime = this.getTime(30)
                    this.param.endTime = this.getTime(1)
                    this._getData()
                }
            }
        },
        deep: true
    },
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/icon";
@import "~common/scss/mixin";
.reportDataAnalysis {
    .title{
        color: $tcolor-base;
        font-size: $font-16;
        margin:0 20px 14px 20px;
    }
    .boxs{
        @include flexBox(space-between);
        .box{
            background: $tcolor-white;
            padding:30px;
            flex-grow: 1;
            .summary{
                font-size: $font-14;
                margin-bottom: 10px;
            }
            .content{
                @include flexBox(space-between);
                .num{
                    font-size: $font-30;
                }
                .icon{
                    display: inline-block;
                }
            }
        }
        .box~.box{
            margin-left: 10px;
        }
    }
    .key-data{
        .summary{
            color: $bgcolor-base;
        }
        .content{
            .num{
                color: $bgcolor-orange;
            }
            .icon{
                width: 52px;
                height: 52px;
            }
        }
        .box:nth-child(1){
            .num{
                color: $bgcolor-base;
            }
        }
    }
    .trend{
        .trendTitle{
            margin-top: 24px;
            padding-top: 4px;
            height: 48px;
            background: $tcolor-white;
            .trendName{
                flex-grow: 1;
            }
            .el-tabs__nav{
                margin-left:20px;
                margin-right:20px;
            }
            .el-range-editor.el-input__inner{
                padding: 3px 5px;
            }
            .el-range-editor.el-input__inner{
                height: 32px;
                line-height: 32px;
            }
            .el-date-editor .el-range__icon{
                line-height: 26px;
            }
            .el-date-editor .el-range-separator{
                line-height: 26px;
            }
        }
    }
    .lineDatas{
        background: $bgcolor-white;
        padding: 20px
    }
}
</style>
